import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';
import { changesSection } from './changes';

export const accessibilityStatement: PolicyDocument = {
  title: 'Accessibility',
  lead: `${c.brand} is committed to making our website usable by everyone.`,
  sections: [
    {
      id: 'commitment',
      heading: 'Our commitment',
      blocks: [
        'We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA. Our website supports keyboard navigation, screen readers, visible focus states, text alternatives for images, sufficient color contrast and reduced-motion preferences.',
      ],
    },
    {
      id: 'ongoing',
      heading: 'Ongoing effort',
      blocks: [
        'Accessibility is an ongoing effort. We review our website regularly and work to address issues as they are identified. Some third-party content and services, such as checkout and payment pages, are provided by our partners.',
      ],
    },
    changesSection('Accessibility Statement'),
    {
      id: 'feedback',
      heading: 'Need help?',
      blocks: [
        `If you have difficulty using any part of this website, email ${c.supportEmail} with the page and the problem you encountered. We will help you complete your purchase or find the information you need, and work to fix the issue.`,
      ],
    },
  ],
};
